<template>
    <ModalBase
        :name="name"
        :title="title"
        :width="width"
        @opened="reset"
        @close="$emit('close')"
    >
        <div @keyup.enter="checkPassword">
            <div class="tw:space-y-4">
                <p v-if="message" class="tw:text-sm tw:text-gray-600">
                    {{ message }}
                </p>
                <BaseInputText
                    v-model="localPassword"
                    type="password"
                    label="Contraseña"
                    name="password"
                    placeholder=" "
                />
                <p v-if="validationError" class="tw:text-xs tw:text-red-500">
                    {{ validationError }}
                </p>
            </div>
        </div>
        <template #footer>
            <div class="tw:flex tw:justify-end">
                <Button variant="ghost" size="sm" @click="close">
                    Cancelar
                </Button>
                <Button size="sm" :disabled="submitting" @click="checkPassword">
                    Confirmar
                </Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref } from 'vue';
    import { getCurrentInstance } from 'vue';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue';
    import Button from '@/modules/admin/ui/Button.vue';

    const props = defineProps({
        name: { type: String, required: true },
        title: { type: String, default: 'Confirmar contraseña' },
        message: { type: String, default: '' },
        requiredPassword: { type: String, default: 'WBya24mY@k7z' },
        width: { type: [Number, String], default: 420 },
    });

    const emit = defineEmits(['confirmed', 'close']);

    const instance = getCurrentInstance();

    const localPassword = ref('');
    const validationError = ref('');
    const submitting = ref(false);

    function reset() {
        localPassword.value = '';
        validationError.value = '';
        submitting.value = false;
    }

    function close() {
        reset();
        instance.proxy.$modal.hide(props.name);
        emit('close');
    }

    function checkPassword() {
        if (!localPassword.value) {
            validationError.value = 'La contraseña es obligatoria';
            return;
        }
        if (localPassword.value !== props.requiredPassword) {
            validationError.value = 'La contraseña es incorrecta';
            return;
        }
        submitting.value = true;
        instance.proxy.$modal.hide(props.name);
        emit('confirmed');
    }
</script>
